<template>
  <div class="tab-comp-container">
    <RexTableCompV2
      :headers="headers"
      :items="data"
      variant="secondary"
      height="4rem"
      :enableDetails="true"
      :enableScrollFooter="false"
      :striped="true"
      :enableInfiniteScroll="false"
    >
      <template
        v-for="(header, index) in headers"
        #[`header-${header.key}`]
        :key="index"
      >
        <div :class="index === 0 ? '' : 'table-content'">
          {{ header.name }}
        </div>
      </template>
      <template
        v-for="(header, index) in headers"
        :key="index"
        #[`body-${header.key}`]="{ item }"
      >
        <div :key="index" :class="index !== 0 ? 'table-content' : ''">
          {{ item[header.key] }}
        </div>
      </template>
      <template #no-data>
        <div class="parent-no-data">
          <div class="no-data-icon">
            <BaseIcon name="noData" width="30" height="30" />
            <div class="inner-text">
              {{ $t('noData') }}
            </div>
          </div>
        </div>
      </template>
    </RexTableCompV2>
  </div>
</template>

<script>
import RexTableCompV2 from '@/rex-components/rex-TableCompV2.vue';

export default {
  name: 'TabContent',
  components: {
    RexTableCompV2,
  },
  props: {
    headers: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-comp-container {
  min-height: 9rem;
  max-height: 9rem;
  overflow-y: auto;
}

.tab-comp {
  width: 30rem;
  border-collapse: collapse;
}

.tab-comp th,
.tab-comp td {
  padding: 0.5rem;
  text-align: left;
}

.no-data-message {
  color: #ccc;
  text-align: center;
  margin-top: 1rem;
}
.no-data-icon {
  width: 100%;
}
.parent-no-data {
  display: flex;
  align-items: center;
  text-align: center;
  height: 100%;
}

.inner-text {
  font-family: $semi-bold;
  font-size: 1em;
  color: $color-brand-accent;
}

.table-content {
  text-align: center;
  width: 100%;
}
</style>
